import { useTranslation } from 'react-i18next';
import { config } from '@/config';
import { Button, Flex, Icon, Text } from '@/ui';
import { AppleIcon } from './AppleIcon';
import { useIsAppleLoginEnabled } from './hooks/useIsAppleLoginEnabled';
import { buildOauthState } from './utils/oauthState';

const APPLE_URL = 'https://appleid.apple.com/auth/authorize';
const AUTH_REDIRECT_PATH = '/oauth/apple';

const getSigninUrl = (redirectTo?: string): string => {
  const payload: Record<string, string> = {
    client_id: config.appleAuth.clientId,
    redirect_uri: `${config.server.url}${AUTH_REDIRECT_PATH}`,
    response_type: 'code',
    // Apple requires form_post whenever name or email is requested.
    response_mode: 'form_post',
    scope: 'name email',
    state: buildOauthState(redirectTo),
  };

  const query = new URLSearchParams(payload);

  return `${APPLE_URL}?${query.toString()}`;
};

type Props = {
  type: 'register' | 'login';
  redirectTo?: string;
};

export const AppleSignInButton = ({
  type,
  redirectTo,
}: Props): JSX.Element | null => {
  const { t } = useTranslation('auth');
  const isEnabled = useIsAppleLoginEnabled();

  if (!isEnabled) {
    return null;
  }

  return (
    <Button
      _hover={{ bgColor: '#333' }}
      as="a"
      bgColor="#000"
      borderRadius="full"
      color="#FFF"
      display="flex"
      fontSize="14px"
      fontWeight="500"
      h={38}
      href={getSigninUrl(redirectTo)}
      justifyContent="center"
      p="0"
      transition="background-color .218s"
    >
      <Flex align="center" gap="2">
        <Icon as={AppleIcon} />
        <Text>{type === 'login' ? t('apple_login') : t('apple_register')}</Text>
      </Flex>
    </Button>
  );
};
